import { LocalParticipant, createLocalAudioTrack } from "twilio-video";
import { addLocalParticipantTrack } from "./addLocalParticipantTrack";

export const publishAudioTrack = async (localParticipant: LocalParticipant) => {
  const localTrack = await createLocalAudioTrack();
  addLocalParticipantTrack(localParticipant, localTrack);
};
